import React, { useState, useEffect } from 'react';
import FacebookLogin from '../../../services/facebookLogin/reactComponent';
import { FacebookOfflineButton } from '../../../components/buttons/facebook';

import { MessageBoxSimple } from '../../../components/MessageBox';

function SignIn({
  affiliateId,
  contactMode,
  facebookLoginActive,
  facebookAppLocale,
  fields,
  locationId,
  loginFromUrl,
  subDir,
  updateFields,
  userType,
  localisations
}) {
  const [showFacebookOffline, setShowFacebookOffline] = useState(false);

  const facebookOffline = () => {
    setShowFacebookOffline(true);
  };

  function handleChange({ field_name, event }) {
    event.target.setCustomValidity('');
    updateFields({ field_name, value: event.target.value, valid: true });
  }
  return (
    <fieldset className="authentication__form">
      {facebookLoginActive ? (
        <>
          <div className="authentication__facebook">
            <FacebookLogin
              wide={true}
              text={localisations.continue_with_facebook}
              language={facebookAppLocale}
              subDirectory={subDir}
              params={{
                loginfrom_url: loginFromUrl,
                custom_password_required: 0,
                location: locationId,
                usertype_new: userType,
                referred_by: affiliateId,
              }}
            />
          </div>
          <div className="authentication__provider-divider">{localisations.or}</div>
        </>
      ) : showFacebookOffline ? (
        <>
          <MessageBoxSimple type="warning">
            <span>{localisations.fb_unavailable}</span>
          </MessageBoxSimple>
          <p className="authentication__email-password">
            {localisations.login_with_email_and_pass}
          </p>
        </>
      ) : (
        <>
          <div className="authentication__facebook">
            <FacebookOfflineButton
              click={facebookOffline}
              wide={true}
              text={localisations.continue_with_facebook}
            />
          </div>
          <div className="authentication__provider-divider">{localisations.or}</div>
        </>
      )}
      <div className="form-group">
        <label className="form-group__title" htmlFor="login_email">
        {localisations.email}
          {showFacebookOffline ? (
            <span className="form-group__hint">
              * {localisations.may_be_fb_email}
            </span>
          ) : null}
        </label>
        <input
          className="form-group__input form-group__input--wide"
          id="login_email"
          name="login_email"
          type="email"
          autoComplete={'email'}
          required={true}
          onInvalid={(event) =>
            event.target.setCustomValidity(localisations.email_req)
          }
          onChange={(event) =>
            handleChange({ field_name: 'login_email', event })
          }
          defaultValue={fields.login_email.value}
        />
      </div>
      <div className="form-group">
        <label className="form-group__title" htmlFor="login_password">
        {localisations.password}
        </label>
        <input
          className="form-group__input form-group__input--wide"
          id="login_password"
          name="login_password"
          type="password"
          autoComplete={'current-password'}
          required={true}
          onInvalid={(event) =>
            event.target.setCustomValidity(localisations.pass_req)
          }
          onChange={(event) => {
            handleChange({ field_name: 'login_password', event });
          }}
          defaultValue={fields.login_password.value}
        />
      </div>
      <div className="authentication__remember-me">
        <div className="form-group__checkbox">
          <input
            type="checkbox"
            name="remember_me"
            id="remember_me"
            defaultChecked={fields.remember_me.value}
            onChange={(event) => {
              updateFields({
                field_name: 'remember_me',
                value: event.target.checked,
              });
            }}
          />
          <label htmlFor="remember_me">{localisations.remember_me}</label>
        </div>
      </div>
      <button className="button button--wide" form="contact_form">
        {contactMode == 'bytel'
          ? localisations.login_and_get_phone_number
          : localisations.login_and_send_message}
      </button>
      <div className="authentication__forgot-password">
        <a
          href={`/${subDir}/passwordreminder.pl`}
          rel="nofollow"
          target="_password"
          title={localisations.retrieve_pass}
          className="forgot_password_link"
        >
          {showFacebookOffline
            ? localisations.dont_know_pass
            : localisations.forgot_password}
        </a>
      </div>
    </fieldset>
  );
}

export default SignIn;
